import { TextFieldTypes } from "@ionic/core";
import { IonInput, IonItem, IonText, IonTextarea } from "@ionic/react";
import { useField } from "formik";
// import { useState } from "react";

interface InputProps {
  label?: string;
  name: string;
  placeholder: string;
  type?: TextFieldTypes;
  textArea?: boolean;
  className?: string;
}
const TextInput: React.FC<InputProps> = props => {
  const [field, meta] = useField(props);
  // const [showPassword, setShowPassword] = useState(false);

  const roundedDefault = (props.className?.indexOf("rounded-") ?? -1) < 0;

  return (
    <div
      className={`border-2 border-primary-50 mx-6 ${
        roundedDefault ? "rounded-[4px]" : ""
      } ${props.className}`}
    >
      <IonItem lines="none">
        {props.textArea ? (
          <IonTextarea
            {...props}
            // This hack prevents the spread of the props.className from affecting the children
            // Consider revising whether or not spreading props into the child elements is a good idea
            className=""
            onIonChange={field.onChange}
            value={field.value}
            autoCorrect="on"
            onBlur={field.onBlur}
            rows={3}
            autoGrow
          />
        ) : (
          <>
            <IonInput
              {...props}
              // This hack prevents the spread of the props.className from affecting the children
              // Consider revising whether or not spreading props into the child elements is a good idea
              className=""
              onIonChange={field.onChange}
              value={field.value}
              autoCorrect="on"
              onBlur={field.onBlur}
              // type={
              //   props.type === "password" && !showPassword ? "password" : "text"
              // }
            />
            {/* {props.type === "password" && (
              <IonText
                slot="end"
                className="underline cursor-pointer"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
              >
                {showPassword ? "Hide" : "Show"}
              </IonText>
            )} */}
          </>
        )}
      </IonItem>
      <IonText className="absolute text-red-400 -mt-20 right-12 text-sm">
        {meta.touched && meta.error}
      </IonText>
    </div>
  );
};

export default TextInput;
